export enum RedirectPage {
    HOME = 'HOME',
    MYPACKS = 'MYPACKS',
    PACK = 'PACK',
}